const makeStagedProgressBarStyling = ({ theme }) => {
  const INACTIVE_GREY = '#CCCCCC'; // Inactive grey color
  const progressBarFilledColor =
    theme?.mvf?.palette?.component?.progressBarFilledColor;
  const progressBarLabelTextColor =
    theme?.mvf?.palette?.primary?.main || 'black';
  const progressBarFontFamily = theme?.mvf?.typography?.fontFamily;

  return {
    progressWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      width: '100%',
    },
    progressContainer: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      width: '100%',
      borderRadius: '4px',
      position: 'relative',
      overflow: 'visible',
      padding: `10px ${theme?.mvf?.spacing?.medium} 10px`,
      maxWidth: '750px',
    },

    stageStyle: (isCompleted, isCurrent, hasConnector) => ({
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      flex: hasConnector ? 1 : 'none',
      position: 'relative',
      zIndex: 1,
    }),

    iconWrapper: {
      display: 'flex',
      alignItems: 'center',
      width: '100%',
      position: 'relative',
      height: '24px',
    },

    stepIcon: (isCompleted, isCurrent) => {
      let backgroundColor;
      if (isCompleted) {
        backgroundColor = progressBarFilledColor;
      } else if (isCurrent) {
        backgroundColor = '#FFFFFF';
      } else {
        backgroundColor = INACTIVE_GREY;
      }

      return {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        width: isCurrent ? '45px' : '40px',
        height: isCurrent ? '45px' : '40px',
        borderRadius: '50%',
        backgroundColor,
        border: isCurrent ? `2px solid ${progressBarFilledColor}` : 'none',
        color: isCurrent ? progressBarFilledColor : '#FFFFFF',
        transition: 'all 0.3s ease',
        zIndex: 2,
        margin: '0 auto',
      };
    },

    connector: (isActive) => ({
      flex: 1,
      height: 3,
      backgroundColor: isActive ? progressBarFilledColor : INACTIVE_GREY,
      borderRadius: 1,
      position: 'relative',
    }),

    labelsContainer: {
      display: 'flex',
      width: '100%',
      position: 'relative',
      maxWidth: '750px',
      height: '22px',
      margin: '15px 0 5px',
    },

    stageLabel: (isCurrent, isFirst, isLast, index, totalStages) => {
      if (!isCurrent) {
        return {
          visibility: 'hidden',
          flex: 1,
        };
      }

      // Calculate position for middle stages to align with their icons
      let position = {};

      let offset = '0px';
      if (index === 1) {
        offset = '12px';
      }
      if (index === 2) {
        offset = '-5px';
      }
      if (isFirst) {
        position = {
          textAlign: 'left',
        };
      } else if (isLast) {
        position = {
          textAlign: 'right',
          marginLeft: 'auto', // Push to the right
        };
      } else {
        // For middle stages, we need to position the label to align with its icon
        // Each stage takes up an equal portion of the container width
        const stageWidth = 100 / (totalStages - 1);
        position = {
          position: 'absolute',
          left: `${index * stageWidth}%`,
          transform: `translateX(calc(-50% + ${offset}))`, // Center the label under the icon
          width: 'auto',
        };
      }

      return {
        fontWeight: '600',
        color: progressBarLabelTextColor,
        lineHeight: '16px',
        letterSpacing: '0.48px',
        fontSize: '12px',
        padding: '3px 16px',
        borderRadius: '16px',
        display: 'inline-block',
        backgroundColor: '#F7F7F7',
        fontFamily: progressBarFontFamily,
        ...position,
      };
    },

    // Add currentStageLabel function for tests and mobile view
    currentStageLabel: {
      fontWeight: '600',
      textAlign: 'center',
      color: progressBarLabelTextColor,
      lineHeight: '16px',
      letterSpacing: '0.48px',
      fontSize: '12px',
      padding: '3px 16px',
      backgroundColor: '#F7F7F7',
      borderRadius: '16px',
      display: 'inline-block',
      margin: '15px 0 5px',
      fontFamily: progressBarFontFamily,
    },
  };
};

export default makeStagedProgressBarStyling;
